import React from "react";
import { Link } from "react-router-dom";
import { models } from "../../data/models";


const FeaturedModels = () => {
  // Get top 3 ranked models 
  const topModels = [...models]
    .sort((a, b) => a.rank - b.rank)
    .slice(0, 3);

  return (
    <section className="bg-gray-900 bg-opacity-0 text-white py-12 px-4">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl font-bold mb-8 text-center">Featured Models</h2>
        <div className="grid md:grid-cols-3 gap-6">
          {topModels.map((model) => (
            <div
              key={model.slug}
              className="bg-gray-800 rounded-xl p-4 shadow hover:shadow-xl transition"
            >
              <img
                src={model.images[0]}
                alt={model.name}
                className="w-full h-48 object-cover rounded-md mb-4"
              />
              <h3 className="text-xl font-semibold">{model.name}</h3>
              <p className="text-sm text-gray-300 mb-3">{model.description}</p>
              <Link
                to={`/model/${model.slug}`}
                className="text-orange-400 hover:underline"
              >
                View Model →
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedModels;
